import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { environment } from '../environments/environment';
import { BASE_PATH } from 'elaad-api';
import { AuthenticationModule, provideAccessTokenInterceptor } from 'authentication';
import { ElaadAuthenticationServiceService } from './services/elaad-authentication-service.service';
import { SharedModule } from 'shared';
import nl from '@angular/common/locales/nl';
import { registerLocaleData } from '@angular/common';
import { LOCALE_ID } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

registerLocaleData(nl);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: BASE_PATH, useValue: environment.serviceUrl },
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAccessTokenInterceptor(),
    importProvidersFrom([BrowserAnimationsModule]),
    importProvidersFrom(SharedModule.forRoot(environment)),
    importProvidersFrom(AuthenticationModule.forRoot(environment, ElaadAuthenticationServiceService)),
    { provide: LOCALE_ID, useValue: 'nl-NL' },
  ],
};
